<template>
  <v-app>
      <!-- Have to maintain slot coz we're still using PortalVue. Otherwise default login forms will not work -->
      <slot></slot>
  </v-app>
</template>

<script>
  export default {
    name: 'Blanklayout',

    components: {

    },
  }
</script>
